const { createConstant } = require('../helpers')

// Check address, this might change
const service = 'appointment-service'
// Get USER Appointment with api API.dev.doctoroncall.com/appointment-service/swgger
module.exports = {
  GET_USER_APPOINTMENTS_LIST: createConstant(service, 'GET_USER_APPOINTMENTS_LIST'),
  GET_USER_APPOINTMENTS_LIST_SUCCESS: createConstant(service, 'GET_USER_APPOINTMENTS_LIST_SUCCESS'),
  GET_USER_APPOINTMENTS_LIST_ERROR: createConstant(service, 'GET_USER_APPOINTMENTS_LIST_ERROR'),
  GET_USER_APPOINTMENTS_LIST_RESET: createConstant(service, 'GET_USER_APPOINTMENTS_LIST_RESET'),

  GET_USER_APPOINTMENT_DETAILS: createConstant(service, 'GET_USER_APPOINTMENT_DETAILS'),
  GET_USER_APPOINTMENT_DETAILS_SUCCESS: createConstant(service, 'GET_USER_APPOINTMENT_DETAILS_SUCCESS'),
  GET_USER_APPOINTMENT_DETAILS_ERROR: createConstant(service, 'GET_USER_APPOINTMENT_DETAILS_ERROR'),
  GET_USER_APPOINTMENT_DETAILS_RESET: createConstant(service, 'GET_USER_APPOINTMENT_DETAILS_RESET'),

  GET_DOCTOR_APPOINTMENT_LIST: createConstant(service, 'GET_DOCTOR_APPOINTMENT_LIST'),
  GET_DOCTOR_APPOINTMENT_LIST_SUCCESS: createConstant(service, 'GET_DOCTOR_APPOINTMENT_LIST_SUCCESS'),
  GET_DOCTOR_APPOINTMENT_LIST_ERROR: createConstant(service, 'GET_DOCTOR_APPOINTMENT_LIST_ERROR'),
  GET_DOCTOR_APPOINTMENT_LIST_RESET: createConstant(service, 'GET_DOCTOR_APPOINTMENT_LIST_RESET'),

  GET_DOCTOR_APPOINTMENT_OVERVIEW: createConstant(service, 'GET_DOCTOR_APPOINTMENT_OVERVIEW'),
  GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS: createConstant(service, 'GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS'),
  GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR: createConstant(service, 'GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR'),
  GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET: createConstant(service, 'GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET'),
}
